import {PageType} from '../../../../components/vessel-filters/types/page-type'
import LoadingState from '../../../../values/loading-state-enum'
import {SortDirection} from '../../my-vessels-filters/types/my-vessel-filter-state'
import {type VesselFilterReduxState} from './vessel-filter-state'

export const DEFAULT_VESSEL_FILTER_STATE: VesselFilterReduxState = {
    pageType: PageType.MY_VESSELS,
    loadingState: LoadingState.NotPopulated,
    locations: undefined,
    searchVesselTagTerm: [],
    searchVesselNameTerm: '',
    searchVesselTerm: '',
    showXButton: false,
    vesselSort: {
        field: 'vessel-name',
        direction: SortDirection.DESC,
    },
    isInactive: false,
}
